<form [formGroup]="organizationForm" autocomplete="off">
  <div class="d-flex justify-content-between">
    <div class="d-flex justify-content-start">
      <app-search
        [initialKeyword]="searchKeyword"
        (emitSearchKeyword)="receiveSearchKeyword($event)"
      ></app-search>
    </div>
    <div class="d-flex justify-content-end">
      <app-select [form]="organizationForm" [control]="organizationForm.controls['limit']" [controlName]="'limit'"
        [filter]="false" [submitted]="submitted" [data]="limits" [name]="'label'" [value]="'value'" [width]="defaultLimitSelectWidth"
      (emitSelectedValue)="receiveSelectedValue($event)" class="select-outline me-2"></app-select>
      @if (isWriteAccessible) {
        <button type="button" class="btn btn-primary" (click)="openAddOrganizationModal()">
          <i-bs name="plus"></i-bs> Add
        </button>
      }
    </div>
  </div>

  <div class="mt-3">
    <app-table [tableConfig]="tableConfig" [module]="'Organization module'" [loading]="loading" (onScrollToBottom)="scrollToBottom($event)"
      [notFoundMessage]="notFoundMessage" (sendEvent)="receiveEvent($event)">
    </app-table>
  </div>
</form>